import get from 'lodash/get';

function getTransactionPaymentMethods(state) {
  return get(state, ['reports', 'transactions', 'paymentMethods']);
}

export default getTransactionPaymentMethods;
